import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
interface AppLayoutProps {
  children: ReactNode;
  currentPage: string;
  navigateTo: (page: string) => void;
}
export function AppLayout({
  children,
  currentPage,
  navigateTo
}: AppLayoutProps) {
  // Don't show layout for home, login, mouzaMap, or cloVerification (public pages)
  if (currentPage === 'home' || currentPage === 'login' || currentPage === 'mouzaMap' || currentPage === 'cloVerification' || currentPage === 'landRecordDetails' || currentPage === 'adminLogin' || currentPage === 'adminDashboard') {
    return <div className="min-h-screen bg-gray-50" data-id="element-23">{children}</div>;
  }
  return <div className="min-h-screen bg-[#F8FAFB] flex" data-id="element-24">
      <Sidebar currentPage={currentPage} navigateTo={navigateTo} data-id="element-25" />

      <div className="flex-1 flex flex-col md:ml-64 min-h-screen" data-id="element-26">
        <Header navigateTo={navigateTo} data-id="element-27" />

        <main className="flex-1 p-4 md:p-8 pb-24 md:pb-8 overflow-x-hidden" data-id="element-28">
          <div className="max-w-7xl mx-auto" data-id="element-29">{children}</div>
        </main>

        <BottomNav currentPage={currentPage} navigateTo={navigateTo} data-id="element-30" />
      </div>
    </div>;
}